module.exports = [4, 53, 10, 10, 12, 11];